import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CustomRouterStateSerializer } from './router/custom-router-state-serializer.class';
import { DocumentLoadingEffects } from '@nha/state/document-loading/document-loading.effects';
import { RouterFacade } from '@nha/state/router/router.facade';
import { nhaRootReducers } from './nha-root.state';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { getBaseHref } from '@nha/functions';

@NgModule({
	imports: [
		StoreModule.forRoot(nhaRootReducers, {
			runtimeChecks: {
				strictStateImmutability: false,
				strictActionImmutability: false
			}
		}),
		StoreRouterConnectingModule.forRoot(),
		StoreDevtoolsModule.instrument({ maxAge: 50, name: 'myNHA', connectInZone: true }),
		EffectsModule.forRoot([DocumentLoadingEffects])
	],
	providers: [
		RouterFacade,
		{ provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
		{ provide: APP_BASE_HREF, useFactory: getBaseHref, deps: [PlatformLocation] }
	]
})
export class NHAStateModule {}
